import { Chip, Text } from '@huspy/briks-web';

export type BadgeProps = {
  name: string;
  textColor?: string;
  backgroundColor?: string;
};

const defaultValues = {
  textColor: '#F4F6F9',
  backgroundColor: '#525763',
};

export const Badge = (
  { name, backgroundColor = defaultValues.backgroundColor, textColor = defaultValues.textColor } : BadgeProps
) => (
  <Chip
    paddingX={ 3 }
    paddingY={ 1 }
    style={ { backgroundColor } }
  >
    <Text
      style={ { color: textColor } }
      size='sm'
      fontWeight={ 500 }
    >
      { name }
    </Text>
  </Chip>
);
